<template>
    <div class="search-user">
        <a-row :gutter="[10, 10]">
            <a-col :span="24">
                <div class="search-label mt10">{{ userType == 'cn' ? $t('program.search_user.title' /* 搜索手机号/姓名： */) : 'Search by Phone/Name:' }}</div>
            </a-col>
            <a-col :span="10">
                <a-input :placeholder="$t('program.search_user.placeholder' /* 手机号/姓名 */)" v-model="query.name" v-if="userType == 'cn'"></a-input>
                <a-input placeholder="Given name or Family name" v-model="query.family_given_name" v-else></a-input>
            </a-col>
            <a-col :span="10">
                <a-input :placeholder="$t('program.search_user.please_input_org_name' /* 单位名称（选填） */)" v-model="query.org_name" v-if="userType == 'cn'"></a-input>
                <a-input placeholder="Email" v-model="query.email" v-else></a-input>
            </a-col>
            <a-col :span="4">
                <a-button type="primary" @click="handleSearchEvent">{{ $t('program.search_user.search_btn' /* 搜索 */) }}</a-button>
            </a-col>
        </a-row>
        <a-spin :spinning="loading">
            <!-- 用户列表 -->
            <transition name="user-list" :appear="true">
                <a-list item-layout="vertical" :data-source="listData" size="small" class="user-list" v-if="showNewUser">
                    <a-list-item slot="renderItem" slot-scope="item, index">
                        <a-list-item-meta>
                            <div slot="title" class="flex x-between pr10">
                                <span class="flex-item mr10">
                                    <span v-if="item.duty_count > 0" style="color: #f00">{{ $t('program.search_user.task_num', { count: item.duty_count } /* [有{ count }条任务] */) }} |&nbsp;</span>
                                    <span v-if="item.is_meeting == 1" style="color: green">{{ $t('program.search_user.attend_meeting' /* [已参会] | */) }}</span>
                                    {{ getUserDisplayInfo(item) }}
                                </span>
                                <a href="javascript:;" :class="item.selected ? 'selected' : ''" @click="handleSelectEvent(index)">
                                    {{ item.selected ? $t('program.search_user.selected' /* 已选中 */) : $t('program.search_user.select' /* 选择 */) }}
                                </a>
                            </div>
                        </a-list-item-meta>
                        <!-- 任务类型列表 -->
                        <ul v-if="item.duty_num && Object.keys(item.duty_num).length" class="duty-num-list flex">
                            <li class="t-c">
                                <div>{{ $t('program.search_user.task_type' /* 任务类型 */) }}</div>
                                <div>{{ $t('program.search_user.task_num' /* 任务数量 */) }}</div>
                            </li>
                            <li v-for="(value, key) in item.duty_num" :key="key" class="t-c">
                                <div>{{ key }}</div>
                                <div>{{ value }}</div>
                            </li>
                        </ul>

                        <!-- 任务列表 -->
                        <a-table
                            class="mt10"
                            v-if="item.duty && item.duty.length"
                            :columns="dutyColumns"
                            :data-source="item.duty"
                            :pagination="false"
                            :rowKey="record => record.id"
                            :scroll="{ x: 400 }"
                            size="small"
                            bordered
                        ></a-table>
                        <!-- 机构信息 -->
                        <a-table
                            v-if="item.org_info && item.org_info.length"
                            :columns="columns"
                            :data-source="item.org_info"
                            :pagination="false"
                            :rowKey="record => record.id"
                            :scroll="{ x: 500 }"
                            size="small"
                            bordered
                        ></a-table>
                    </a-list-item>
                    <a-list-item class="list-add-item" v-if="showNewUser">
                        <div class="add-user-content">
                            <span class="color000 mr10">{{ $t('program.search_user.no_result' /* 如未查询到用户请点击 */) }}</span>
                            <a-button type="primary" @click="handleAddUserEvent" size="small">{{ $t('program.search_user.new' /* 新增 */) }}</a-button>
                        </div>
                    </a-list-item>
                </a-list>
            </transition>
        </a-spin>

        <!-- 用户表单 -->
        <!-- <a-form :form="form" class="new-user-form" v-if="needForm && showForm"> -->
        <a-row :gutter="[10, 5]" v-if="needForm && showForm">
            <a-col :span="24">
                <a-form-item>
                    <div v-decorator="['id']">
                        <span class="color000">{{ $t('program.search_user.user_id' /* 用户ID */) }}：</span>
                        {{ form.getFieldValue('id') || 0 }}
                    </div>
                </a-form-item>
            </a-col>
            <a-col :span="8">
                <a-form-item :label="$t('program.search_user.name' /* 汉字姓名 */)" required>
                    <span v-if="selectedUser.real_name || userInfo.real_name">{{ selectedUser.real_name || userInfo.real_name }}</span>
                    <a-input
                        v-else
                        v-decorator="[
                            'real_name',
                            {
                                rules: [{ validator: validateRealNameFun }],
                                trigger: 'blur'
                            }
                        ]"
                    ></a-input>
                </a-form-item>
            </a-col>
            <a-col :span="8">
                <a-form-item :label="$t('program.search_user.xing' /* 姓的拼音 */)">
                    <a-input
                        v-decorator="[
                            'family_name',
                            {
                                rules: [{ required: true, message: $t('program.search_user.please_input_xing' /* 请输入姓的拼音 */) }],
                                trigger: 'blur'
                            }
                        ]"
                    ></a-input>
                </a-form-item>
            </a-col>
            <a-col :span="8">
                <a-form-item :label="$t('program.search_user.ming' /* 名的拼音 */)">
                    <a-input
                        v-decorator="[
                            'given_name',
                            {
                                rules: [{ required: true, message: $t('program.search_user.please_input_ming' /* 请输入名的拼音 */) }],
                                trigger: 'blur'
                            }
                        ]"
                    ></a-input>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item :label="$t('program.search_user.abbreviation' /* 姓名首字母简拼 */)">
                    <a-input
                        v-decorator="[
                            'abbreviation',
                            {
                                rules: [{ required: true, message: $t('program.search_user.please_input_abbreviation' /* 请输入姓名首字母简拼 */) }],
                                trigger: 'blur'
                            }
                        ]"
                    ></a-input>
                    <template slot="extra">
                        <span style="color: #f00">{{ $t('program.search_user.reg' /* 用于讲者主持列表按照姓名拼音顺序排序时使用，请填写姓名首字母，比如姓名为王一一，则填写wyy。 */) }}</span>
                    </template>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <select-city :dataValue="citySelectData" :cityLabel="$t('program.search_user.country' /* 国家 */)" :form="form" :needCountry="1" style="width: 100%"></select-city>
            </a-col>
            <a-col :span="24">
                <select-city :dataValue="citySelectData" :cityLabel="$t('program.search_user.region' /* 所属地区 */)" :form="form" :needCountry="3" style="width: 100%"></select-city>
            </a-col>
            <a-col :span="12">
                <a-form-item :label="$t('program.search_user.org_cnname' /* 所在单位 */)">
                    <a-input
                        v-decorator="[
                            'org_cnname',
                            {
                                rules: [{ required: true, message: $t('program.search_user.please_input_org_cnname' /* 请输入所在单位 */) }],
                                trigger: 'blur'
                            }
                        ]"
                    ></a-input>
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item :label="$t('program.search_user.org_enname' /* 英文单位 */)">
                    <a-input v-decorator="['org_enname']"></a-input>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item :label="$t('program.search_user.department' /* 科室部门 */)">
                    <a-input v-decorator="['department']"></a-input>
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item :label="$t('program.search_user.address' /* 通讯地址 */)">
                    <a-input v-decorator="['address']"></a-input>
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item :label="$t('program.search_user.zipcode' /* 邮政编码 */)">
                    <a-input v-decorator="['zipcode']"></a-input>
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item :label="$t('program.search_user.phone' /* 手机号码 */)" v-if="userType == 'cn'" required>
                    <span v-if="selectedUser.mobile || userInfo.mobile">{{ selectedUser.mobile || userInfo.mobile }}</span>
                    <a-input
                        v-else
                        v-decorator="[
                            'mobile',
                            {
                                rules: [{ validator: validateMobileFun }],
                                trigger: 'blur'
                            }
                        ]"
                    ></a-input>
                </a-form-item>

                <a-form-item v-else :label="$t('program.search_user.tel_no' /* 电话号码 */)">
                    <div class="flex y-center">
                        <span class="mr10">+86</span>
                        <a-input v-decorator="['org_tel']"></a-input>
                    </div>
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item :label="$t('program.search_user.email' /* 电子邮箱 */)">
                    <span v-if="selectedUser.email || userInfo.email">{{ selectedUser.email || userInfo.email }}</span>
                    <a-input v-else v-decorator="['email', { rules: [{ required: userType == 'cn' ? false : true, validator: validateEmailFun }], trigger: 'blur' }]"></a-input>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item :label="$t('program.search_user.org_cnname_d' /* 日程显示中文单位 */)">
                    <a-input v-decorator="['org_cnname_d']"></a-input>
                    <template slot="extra">
                        <span style="color: #f00">{{ $t('program.search_user.only_fill_when_different' /* 只有日程显示单位与用户单位不一致时填写，如果一致不需要填写 */) }}</span>
                    </template>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item :label="$t('program.search_user.org_enname_d' /* 日程显示英文单位 */)">
                    <a-input v-decorator="['org_enname_d']"></a-input>
                    <template slot="extra">
                        <span style="color: #f00">{{ $t('program.search_user.only_fill_when_different' /* 只有日程显示单位与用户单位不一致时填写，如果一致不需要填写 */) }}</span>
                    </template>
                </a-form-item>
            </a-col>

            <a-col :span="12">
                <a-form-item :label="$t('program.search_user.post_name' /* 职务 */)">
                    <a-input v-decorator="['post_name']"></a-input>
                </a-form-item>
            </a-col>
        </a-row>
        <!-- </a-form> -->
        <!-- 新增用户弹窗 -->
        <a-modal class="new-user-form" v-model="newUserVisible" width="500px" :title="$t('program.search_user.new_user_title' /* 新增用户 */)" @cancel="handleNewUserCancel" @ok="handleNewUserOk">
            <a-spin :spinning="newUserLoading">
                <a-form :form="userForm">
                    <a-form-item :label="$t('program.search_user.phone' /* 手机号 */)">
                        <a-input
                            v-decorator="[
                                'mobile',
                                {
                                    rules: [
                                        { required: true, message: $t('program.search_user.please_input_phone' /* 请输入手机号码 */) },
                                        { pattern: /^1[3456789]\d{9}$/, message: $t('program.search_user.phone_format_error' /* 手机号码格式不正确 */) }
                                    ],
                                    trigger: 'blur'
                                }
                            ]"
                        ></a-input>
                    </a-form-item>
                    <a-form-item :label="$t('program.search_user.real_name' /* 姓名 */)">
                        <a-input v-decorator="['real_name', { rules: [{ required: true, message: $t('program.search_user.please_input_real_name' /* 请输入姓名 */) }] }]"></a-input>
                    </a-form-item>
                    <a-form-item :label="$t('program.search_user.org_cnname' /* 单位 */)">
                        <a-input v-decorator="['org_cnname']"></a-input>
                    </a-form-item>
                </a-form>
            </a-spin>
        </a-modal>
    </div>
</template>
<script>
import selectCity from './select-city.vue';
import pick from 'lodash/pick';
const fields = [
    'id',
    'real_name',
    'family_name',
    'given_name',
    'abbreviation',
    'province_id',
    'city_id',
    'area_id',
    'org_cnname',
    'org_enname',
    'department',
    'address',
    'zipcode',
    'mobile',
    'email',
    'org_tel',
    'post_name',
    'country_id'
];
export default {
    name: 'SearchUser',
    props: {
        userInfo: {
            default: () => {},
            type: Object
        },
        userType: {
            default: 'cn', // 用户类型
            type: String // cn中宾 en外宾
        },
        searchUrl: {
            default: 'getProgramSearchDuty',
            type: String
        },
        needForm: {
            default: true,
            type: Boolean
        },
        form: {
            type: Object,
            default: null
        }
    },
    components: { selectCity },
    data() {
        return {
            query: {
                name: '',
                org_name: '',
                family_given_name: '',
                email: ''
            },
            listData: [],
            columns: [
                {
                    title: this.$t('program.search_user.member' /* 委员会 */),
                    dataIndex: 'name',
                    key: 'name',
                    width: 180
                },
                {
                    title: this.$t('program.search_user.sequence' /* 届数 */),
                    dataIndex: 'Sequence',
                    key: 'Sequence',
                    width: 70
                },
                {
                    title: this.$t('program.search_user.xzname' /* 任职机构 */),
                    dataIndex: 'xzname',
                    key: 'xzname',
                    width: 90
                },
                {
                    title: this.$t('program.search_user.post' /* 职务 */),
                    dataIndex: 'position',
                    key: 'position',
                    width: 80
                },
                {
                    title: this.$t('program.search_user.begin_time' /* 任职开始时间 */),
                    dataIndex: 'BeginTime',
                    key: 'BeginTime',
                    width: 120
                },
                {
                    title: this.$t('program.search_user.end_time' /* 任职结束时间 */),
                    dataIndex: 'EndTime',
                    key: 'EndTime',
                    width: 120
                }
            ],
            showNewUser: false,
            // form: this.$form.createForm(this),
            citySelectData: {
                province_id: '',
                city_id: '',
                area_id: '',
                country_id: ''
            },
            dutyNum: [],
            dutyList: [],
            dutyColumns: [
                {
                    title: this.$t('program.search_user.date' /* 日期 */),
                    dataIndex: 'meeting_date',
                    key: 'meeting_date',
                    width: 150
                },
                {
                    title: this.$t('program.search_user.hall' /* 会场 */),
                    dataIndex: 'meeting_hall',
                    key: 'meeting_hall',
                    width: 150
                },
                {
                    title: this.$t('program.search_user.task' /* 任务 */),
                    dataIndex: 'typename_cn',
                    key: 'typename_cn',
                    width: 100
                }
            ],
            showForm: false,
            loading: false,
            newUserVisible: false,
            userForm: this.$form.createForm(this),
            newUserLoading: false,
            selectedUser: {}
        };
    },

    watch: {
        userInfo: {
            // 回显
            handler(newVal) {
                if (newVal.user_id) {
                    this.showForm = true;
                    this.citySelectData = {
                        province_id: newVal.province_id,
                        city_id: newVal.city_id,
                        area_id: newVal.area_id,
                        country_id: newVal.country_id
                    };
                    this.$nextTick(() => {
                        this.form.setFieldsValue(pick(newVal, fields));
                    });
                }
            }
        }
    },

    methods: {
        /**
         * ## 搜索
         */
        handleSearchEvent() {
            this.loading = true;
            this.$request
                .get({ url: this.searchUrl, data: this.query, costom: { hideModal: true } })
                .then(res => {
                    this.listData = res.data.map(item => ({
                        ...item,
                        selected: false
                    }));
                })
                .finally(() => {
                    this.loading = false;
                    this.showNewUser = true;
                });
        },
        /**
         * ## 选中
         */
        handleSelectEvent(index) {
            this.listData.forEach((item, idx) => {
                if (index == idx) {
                    this.selectedUser = this.listData[index];
                    this.$set(this.selectedUser, 'selected', true);
                    this.citySelectData = {
                        province_id: this.selectedUser.province_id,
                        city_id: this.selectedUser.city_id,
                        area_id: this.selectedUser.area_id,
                        country_id: this.selectedUser.country_id
                    };
                    this.$nextTick(() => {
                        this.form.setFieldsValue(pick(this.selectedUser, fields));
                    });
                    if (!this.needForm) {
                        // 不需要表单时，选中用户后收起用户列表
                        this.showNewUser = false;
                    }
                    this.$emit('select', this.selectedUser);
                } else {
                    this.$set(this.listData[idx], 'selected', false);
                }
            });
            this.showForm = true;
        },
        /**
         * ## 新增用户
         */
        handleAddUserEvent() {
            if (this.needForm) {
                this.showNewUser = false;
                this.showForm = true;
                this.citySelectData = {
                    province_id: '',
                    city_id: '',
                    area_id: '',
                    country_id: ''
                };

                this.form.resetFields();
                this.form.setFieldsValue({ id: '0' });
            } else {
                this.newUserVisible = true;
            }
        },
        /**
         * ## 重置
         */
        reset() {
            this.query.name = '';
            this.query.org_name = '';
            this.query.family_given_name = '';
            this.query.email = '';
            this.listData = [];
            this.showNewUser = false;
            this.showForm = false;
        },
        validate() {
            return new Promise((resolve, reject) => {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        // 搜索出的用户不需要传
                        if (values.id && values.id != 0) {
                            delete values.mobile;
                            delete values.real_name;
                            delete values.email;
                        }
                        resolve(values);
                    }
                });
            });
        },
        /**
         * 用户信息展示
         */
        getUserDisplayInfo(item) {
            const lang = this.$route.params.lang;
            const name = lang === 'cn' ? item.real_name : `${item.given_name} ${item.family_name}`;
            const org = lang === 'cn' ? item.org_cnname : item.org_enname;
            const deptMobile = item.department ? `${item.department}，${item.mobile}` : `${item.mobile}`;
            let result = `${item.id}：`;
            if (name) result += name;
            if (org) result += (name ? '，' : '') + org;
            if (deptMobile) result += (name || org ? '，' : '') + deptMobile;
            return result;
        },
        /**
         * 新增用户确定
         */
        handleNewUserOk() {
            this.userForm.validateFields((error, values) => {
                if (!error) {
                    this.newUserLoading = true;
                    this.$request
                        .post({
                            url: 'addRelatedVideoUsers',
                            data: values
                        })
                        .then(res => {
                            this.$message.success(this.$t('program.search_user.new_success' /* 新增成功 */));
                            this.newUserVisible = false;
                            this.$emit('select', { id: res.data.user_id, ...res.data });
                        })
                        .finally(() => {
                            this.newUserLoading = false;
                        });
                }
            });
        },
        /**
         * 新增用户取消
         */
        handleNewUserCancel() {
            this.userForm.resetFields();
            this.newUserVisible = false;
        },
        /**
         * 验证邮箱
         */
        validateEmailFun(rule, value, callback) {
            // 为空直接通过，required 交给 rules 处理
            if (!value) {
                return callback(new Error(this.$t('program.search_user.please_input_email' /* 请输入邮箱 */)));
            }
            // 异步校验用户是否存在
            this.$request.get({ url: 'validUsername', data: { username: value } }).then(res => {
                const { code, message } = res;
                if (code === 200) {
                    if (message === 'y') {
                        callback(new Error(this.$t('program.search_user.has_exist' /* 账号已存在,请勿重复添加 */)));
                    } else {
                        callback();
                    }
                } else {
                    callback(new Error(message));
                }
            });
        },
        /**
         * 验证手机号
         */
        validateMobileFun(rule, value, callback) {
            if (!value) {
                return callback(new Error(this.$t('program.search_user.please_input_phone' /* 请输入手机号码 */)));
            }
            if (!/^1[3456789]\d{9}$/.test(value)) {
                return callback(new Error(this.$t('program.search_user.phone_format_error' /* 手机号码格式不正确 */)));
            }
            this.$request.get({ url: 'validUsername', data: { username: value } }).then(res => {
                const { code, message } = res;
                if (code === 200) {
                    if (message === 'y') {
                        callback(new Error(this.$t('program.search_user.has_exist' /* 账号已存在,请勿重复添加 */)));
                    } else {
                        callback();
                    }
                } else {
                    callback(new Error(message));
                }
            });
        },
        /**
         * 验证姓名
         */
        validateRealNameFun(rule, value, callback) {
            if (!value) {
                return callback(new Error(this.$t('program.search_user.please_input_real_name' /* 请填写汉字姓名 */)));
            }
            this.$request.get({ url: 'getPinyin', data: { real_name: value } }).then(res => {
                const { code, message, data } = res;
                if (code === 200) {
                    this.form.setFieldsValue({ family_name: data.family_name, given_name: data.given_name });
                    callback();
                } else {
                    callback(new Error(message));
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
ul,
li {
    list-style: none;
    padding: 0;
    margin: 0;
}
.search-label {
    line-height: 1;
}
.user-list {
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
}
.selected {
    color: #999;
}

.ant-list-vertical .ant-list-item-meta-title,
.ant-list-vertical .ant-list-item-meta {
    margin-bottom: 0px;
    font-size: 14px;
}
.list-add-item {
    height: 48px;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-top: 1px solid #f0f0f0; // 与ant-list分割线风格一致
    background: #fafafa; // 可选，弱化背景
    .add-user-content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center; // 居中显示，如需左对齐可用flex-start
        .color000 {
            color: #333;
            font-size: 14px;
        }
        .ant-btn {
            margin-left: 8px;
            margin-top: 0;
        }
    }
}
.ant-form-item {
    margin-bottom: 0px;
}
.new-user-form {
    :deep(.ant-form-item-label) {
        line-height: 2;
    }
}
:deep(.ant-table-thead > tr > th),
:deep(.ant-table-tbody > tr > td) {
    padding: 5px !important;
}
:deep(.ant-table-thead > tr > th) {
    background: #fafafa !important;
    color: #000 !important;
}
.duty-num-list {
    margin-top: 10px;
    li {
        border-right: 1px solid #e8e8e8;
        border-top: 1px solid #e8e8e8;
        border-bottom: 1px solid #e8e8e8;
        flex: 1;
        &:first-child {
            div {
                border-left: 1px solid #e8e8e8;
            }
        }
        div {
            &:first-child {
                border-bottom: 1px solid #e8e8e8;
                background: #fafafa;
                color: #000;
            }
            padding: 5px;
        }
    }
}
.user-list-enter {
    height: 0;
}
.user-list-enter-active,
.user-list-leave-active {
    transition: all 0.5s;
}
.user-list-enter-to {
    height: 40px;
}
.user-list-leave {
    height: 100px;
}
.user-list-leave-to {
    height: 0;
}
</style>